// wishlist-button.js — fixed 2026-06-04 to bypass WK state-machine guard (see comment above bindClicks)
(function () {
  var BUTTON_SELECTOR = '.wishlist-button';
  var READY_TIMEOUT_MS = 10000;
  var itemMap = new Map();

  function ready() {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function check() {
        var wk = window.WishlistKing;
        if (wk && wk._apis && wk._apis.wishlist && typeof wk._apis.wishlist.addItem === 'function') return resolve(wk);
        if (Date.now() - start > READY_TIMEOUT_MS) return reject(new Error('WishlistKing not loaded'));
        setTimeout(check, 100);
      })();
    });
  }

  function refreshButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (btn) {
      var variantId = String(btn.dataset.variantId || '');
      var active = itemMap.has(variantId);
      btn.classList.toggle('is-in-wishlist', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateWishlistCount();
  }

  // Updates the count bubble on the header wishlist heart (mirrors the cart count bubble).
  // The header markup ships with `<span data-wishlist-count class="wishlist-king-count cart-item-count-bubble cart-item-count-header" style="display: none;">0</span>`;
  // the WK app would populate it via its own state-machine flow, but we bypass that here.
  function updateWishlistCount() {
    var count = itemMap.size;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function syncFromWishlist(wishlist) {
    itemMap.clear();
    (wishlist.items || []).forEach(function (item) {
      var vid = item.variantId != null ? item.variantId : item.selectedVariantId;
      if (vid != null) itemMap.set(String(vid), item.id);
    });
    refreshButtons();
  }

  function loadWishlist(wk) {
    return wk._apis.wishlist.loadWishlist({ wishlistId: 'mine' }).then(function (res) {
      syncFromWishlist(res.wishlist);
    }).catch(function (err) { console.warn('[wishlist] load failed', err); });
  }

  // Why we use wk._apis.wishlist directly instead of wk.addWishlistItem / wk.removeWishlistItem:
  //   The state-machine wrappers (wk.addWishlistItem etc.) set an internal "submitting"
  //   lock on entry. The lock is only released by an `observeWishlist` subscriber
  //   firing — which exists on /pages/wishlist (the WishlistElement custom element
  //   subscribes via getStateConfig) but NOT on any other page. On a PLP / PDP the
  //   lock never clears after the first action and every subsequent click silently
  //   no-ops until a full page reload. The low-level API call has no such guard.
  function bindClicks(wk) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(BUTTON_SELECTOR);
      if (!btn || btn.disabled) return;
      var productId = parseInt(btn.dataset.productId, 10);
      var variantIdStr = String(btn.dataset.variantId || '');
      var variantId = parseInt(variantIdStr, 10);
      if (!productId || !variantId) return;
      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;

      var op;
      if (itemMap.has(variantIdStr)) {
        var existingItemId = itemMap.get(variantIdStr);
        itemMap.delete(variantIdStr);
        refreshButtons();
        op = wk._apis.wishlist.removeItem({ wishlistId: 'mine', wishlistItemId: existingItemId }).catch(function (err) {
          itemMap.set(variantIdStr, existingItemId);
          refreshButtons();
          console.error('[wishlist] remove failed', err);
        });
      } else {
        itemMap.set(variantIdStr, '__pending__');
        refreshButtons();
        op = wk._apis.wishlist.addItem({ productId: productId, variantId: variantId }).then(function (res) {
          if (res && res.wishlistItem) {
            itemMap.set(variantIdStr, res.wishlistItem.id);
          }
          // When the user has no session yet, the first addItem response carries a new
          // sessionId. wk.addWishlistItem (the state-machine wrapper) propagates this via
          // an `app:init-sid` event; since we bypass that wrapper, do it manually here.
          // Without this, each click hits an empty session and the server creates a new
          // wishlist per click — items appear to "add" in the UI but the wishlist page
          // ends up empty because the header heart reads from the latest session.
          if (res && res.sessionId) {
            try { wk._apis.wishlist.setSessionId(res.sessionId); } catch (e) {}
            if (wk.events && typeof wk.events.publish === 'function') {
              try { wk.events.publish({ name: 'app:init-sid', data: { sessionId: res.sessionId } }); } catch (e) {}
            }
          }
        }).catch(function (err) {
          itemMap.delete(variantIdStr);
          refreshButtons();
          console.error('[wishlist] add failed', err);
        });
      }
      op.then(function () { btn.disabled = false; });
    });
  }

  function init() {
    ready().then(function (wk) {
      bindClicks(wk);
      return loadWishlist(wk);
    }).catch(function (err) {
      console.warn('[wishlist]', err && err.message);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
